import React, { useEffect } from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { Clock } from "lucide-react";

/**
 * Page wrapper for every calculator. Renders Nav + Footer + a consistent
 * editorial header (eyebrow, title, blurb, duration pill). Children render
 * inside the main column.
 */
export const CalculatorShell = ({
  eyebrow = "Interactive Tool",
  title,
  blurb,
  duration,
  children,
  Icon,
}) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <div data-testid="calculator-page" className="min-h-screen bg-lw-ivory">
      <Nav />
      <main className="pt-28 sm:pt-32 lg:pt-36 pb-20">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 lg:px-12">
          <div className="flex items-start justify-between flex-wrap gap-4 mb-3">
            <span className="lw-eyebrow">{eyebrow}</span>
            {duration && (
              <span className="lw-pill" data-testid="tool-duration">
                <Clock size={12} /> {duration}
              </span>
            )}
          </div>
          <div className="flex items-start gap-4 mb-6">
            {Icon && (
              <div
                className="hidden sm:flex w-12 h-12 rounded-xl items-center justify-center bg-lw-navy text-[#FAF8F3]"
                aria-hidden="true"
              >
                <Icon size={22} />
              </div>
            )}
            <div>
              <h1
                data-testid="tool-title"
                className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-lw-navy leading-[1.1]"
              >
                {title}
              </h1>
              {blurb && (
                <p className="mt-3 max-w-2xl text-base sm:text-lg text-lw-muted leading-relaxed">
                  {blurb}
                </p>
              )}
            </div>
          </div>
          <div className="gold-hairline opacity-60 my-8" />
          <div className="space-y-8">{children}</div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CalculatorShell;
